<template>
    <div>
        <CRow class="filter-row">
            <CCol col="12" sm="12" lg="10">
                <FilterIt :selectableStores="selectableStores" />
            </CCol>
        </CRow>
        <CRow>
            <Loading style="position: fixed !important;" />
            <CCol col="12" sm="12" lg="10" class="col-card">
                <ProductGrid class="product-grid" />
            </CCol>
            <CCol col="12" sm="12" lg="2" class="filter-col">
                <ProductFilter :selectableStores="selectableStores" />
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ProductGrid, ProductFilter, FilterIt } from './partials'
import { storeService } from '@/services/api'
import { StoreStatus } from '@/constants'

export default {
    name: 'List',

    beforeRouteEnter (to, from, next) {
        next(vm => {
            storeService.fetch({
                no_paginate: true,
                has_product: true,
                just: ['id', 'name'],
                status: StoreStatus.ACTIVE
            }).then(res => {
                vm.selectableStores = res.data.data
            })
        })
    },

    data() {
        return {
            selectableStores: []
        }
    },

    components: {
        FilterIt,
        ProductGrid,
        ProductFilter
    },
}
</script>
<style scoped>
.col-card {
    margin-right: 20px;
}
.filter-row {
    margin: -20px 45px 10px 0;
    display: none;
}
.filter-col {
    margin-right: -74px;
}
@media only screen and (max-width: 1270px) {
    .filter-col {
        margin-right: -84px;
    }
}
@media only screen and (max-width: 1070px) {
    .filter-col {
        margin-right: -94px;
    }
}
@media only screen and (max-width: 1145px) {
    .col-card {
        margin-right: 0px;
    }
}
@media only screen and (max-width: 985px) {
    .filter-col {
        display: none;
    }
    .product-grid {
        margin-right: 70px;
    }
    .filter-row {
        display: block;
    }
}
@media only screen and (max-width: 575px) {
    .product-grid {
        margin-right: 25px;
    }
    .filter-row {
        margin: -20px 0 10px;
    }
}
</style>